export { default as request } from "./_request";
export { default as format } from "./_format";
export function parseEndpoint(path){
    let pathArray = path.split('.');
    let url;

    if(pathArray[0] === "profile"){
        if(pathArray.length === 1){
            url = ''
        }else{
            url = pathArray.join('/')
        }
    }else{
        url = "/"+pathArray.join('/')
    }

    return {
        url,
        id: pathArray.length > 1 ? pathArray[pathArray.length -1 ] : null,
        resource: pathArray[0]
    }
}